<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title"></h4>
                        <p class="category"></p>
                    </div>

                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-10">
                                <p>General - Regular - 2.0</p>
                            </div>
                            <div class="col-md-2 text-right">
                                <i [routerLink]="['/app','assigned_raters']" class="material-icons">reply</i>
                                <i class="material-icons">share</i>
                                <i class="material-icons">file_download</i>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <p>Completed on: 04/01/2018</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                Client - John Doe
                            </div>
                        </div>

                        <br />

                        <tabset>
                            <tab title="">
                                <span *tabHeading>
                                    <b style="color: deepskyblue">ELI Results</b>
                                </span>
                                <div class="border">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <h5><b>Energetic Profile</b></h5>
                                            <!--(chartHover)="chartHovered($event)"
                                            (chartClick)="chartClicked($event)"-->
                                            <div>
                                                <canvas baseChart
                                                        [datasets]="profileDatasets"
                                                        [labels]="profileLabel"
                                                        [options]="profileOptions"
                                                        [legend]="profileLegend"
                                                        [chartType]="profileChartType"
                                                        [colors]="colors"></canvas>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <h5><b>Energetic Stress Reaction</b></h5>
                                            <!--(chartHover)="chartHovered($event)"
                                            (chartClick)="chartClicked($event)"-->
                                            <div>
                                                <canvas baseChart
                                                        [datasets]="reactionDatasets"
                                                        [labels]="reactionLabel"
                                                        [options]="reactionOptions"
                                                        [legend]="reactionLegend"
                                                        [chartType]="reactionChartType"
                                                        [colors]="colors"></canvas>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </tab>
                            <tab title="">
                                <span *tabHeading>
                                    <b style="color: deepskyblue">360 Results</b>
                                </span>
                                <div class="border">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <select class="input">
                                                <option selected="selected" class="option">Your Ability to: </option>
                                                <option class="option">The extent to which you appear to: </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <!--(chartHover)="chartHovered($event)"
                                            (chartClick)="chartClicked($event)"-->
                                            <span>Recognize other's strengths and gifts</span>
                                            <canvas baseChart
                                                    [datasets]="graphic1Datasets"
                                                    [labels]="graphic1Label"
                                                    [options]="graphic1Options"
                                                    [legend]="graphic2Legend"
                                                    [chartType]="graphic2ChartType"
                                                    [colors]="colors"></canvas>                  
                                        </div>
                                        <div class="col-md-6">
                                            <span>Motivate and inspirate others</span>
                                            <!--(chartHover)="chartHovered($event)"
                                            (chartClick)="chartClicked($event)"-->
                                            <canvas baseChart
                                                    [datasets]="graphic2Datasets"
                                                    [labels]="graphic2Label"
                                                    [options]="graphic2Options"
                                                    [legend]="graphic2Legend"
                                                    [chartType]="graphic2ChartType"
                                                    [colors]="colors"></canvas>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="row">
                                        <div class="col-md-6">
                                            <span>Plan and develop accountability systems ( as opposed to working in a constant crisis or reactionary mode)</span>
                                            <!--(chartHover)="chartHovered($event)"
                                            (chartClick)="chartClicked($event)"-->
                                            <canvas baseChart
                                                    [datasets]="graphic3Datasets"
                                                    [labels]="graphic3Label"
                                                    [options]="graphic3Options"
                                                    [legend]="graphic3Legend"
                                                    [chartType]="graphic3ChartType"
                                                    [colors]="colors"></canvas>
                                        </div>
                                        <div class="col-md-6">
                                            <span>Listen deeply and respond in a way that demonstrates you've understood the meaning and significance of what they've shared with you</span>
                                            <!--(chartHover)="chartHovered($event)"
                                            (chartClick)="chartClicked($event)"-->
                                            <canvas baseChart
                                                    [datasets]="graphic4Datasets"
                                                    [labels]="graphic4Label"
                                                    [options]="graphic4Options"
                                                    [legend]="graphic4Legend"
                                                    [chartType]="graphic4ChartType"
                                                    [colors]="colors"></canvas>
                                        </div>
                                    </div>
                                </div>
                            </tab>
                            <tab title="">
                                <span *tabHeading>
                                    <b style="color: deepskyblue">ELI Answers</b>
                                </span>
                                <div class="border">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="col-md-12">
                                                <label>Level: </label>
                                                <select class="input">
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                    <option value="6">6</option>
                                                    <option value="7">7</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="col-md-6">
                                                <p>1.  I feel guilty for things I've done.</p>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="bar percent20">
                                                    <span>Completely untrue</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="col-md-6">
                                                <p>8.  I feel as though I have a constant weight on my shoulders.</p>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="bar percent60">
                                                    <span>Somewhat true</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="col-md-6">
                                                <p>15. I get disappointed and upset when things don't go my way.</p>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="bar percent100">
                                                    <span>Completely true</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </tab>
                            <tab title="">
                                <span *tabHeading>
                                    <b style="color: deepskyblue">360 Answers</b>
                                </span>
                                <div class="border">

                                </div>
                            </tab>
                        </tabset>
                    </div>
                    <br />
                </div>
            </div>
        </div>
    </div>
</div>
